<template>
  <body>
    <div class="about">
      <div class="about-info">
        <p>
          {{ about_info[0].text1 }}<span class="hello-there">hello there!</span>
          {{ about_info[0].text2.join(" ") }}
          {{ about_info[0].text3.join(" ") }}
        </p>
      </div>
      <img
        v-if="!mobile"
        id="me-img"
        :src="require(`@/assets/images/${meImgPath}`)"
        @mouseleave="meImgPath='me.jpg'"
        @mouseenter="meImgPath='me-ascii_inverted2.png'"
      >
    </div>
  </body>
</template>

<script setup>
import aboutInfo from '../data/about_info.json';
import { ref } from "vue";

// height: window.innerHeight / 2,
const about_info =  ref(aboutInfo);
const meImgPath = ref('me.jpg');
const props = defineProps({
  mobile: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss">
$xs: 360px;
$sm: 540px;
$md: 768px;
$lg: 960px;
$xl: 1200px;

.hello-there {
  font-style: italic;
  color: gold;
}

body {
  margin: .55rem;
  background-color: black;
  min-height: 98vh;
}

p {
  font-family: Simply-Rounded;
  @media(max-width: $md) {
    font-size: 15px;
  }
  @media (min-width: $md) {
    font-size: 20px;
  }
  color: white;
  text-shadow: 0px 3px rgba(190, 36, 190, 0.5);
}

#me-img {
  display: none;
  flex-shrink: 0;
  margin-top: 2rem;
  @media (min-width: $xl) {
    display: inherit;
    width: 25%;
    max-width: 25%;
    min-width: 25%;
  }
  margin-bottom: 2rem;
  @include hr-outline;
}

.about {
  display: flex;
  justify-content: center;
  @media(max-width: $md) {
    flex-direction: column;
  }
}

.about-info {
  @media(min-width: $md) {
    width: 50%;
    margin-top: 2rem;
  } 
  @media(max-width: $sm) {
    padding-left: .5rem;
  }
  border: 5px white solid;
  background-color: black;
  height: fit-content;
}

</style>
